import styled from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';

interface SortOptionElementProps {
  $active?: boolean;
}

export const SortOptionElement = styled.div<SortOptionElementProps>`
  padding: 1.2rem;
  font-weight: 500;
  cursor: pointer;
  font-size: ${FontSizes.medium};
  background-color: ${({ $active }) => ($active ? '#F5F6F7' : 'transparent')};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.namedColors.primary : '#2C363F'};
  border-radius: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;
